import * as React from "react";
import { useState } from "react";
import { Button, Table, Modal, Form, Input, Row, Col, Space, Popconfirm, Popover } from "antd";
import { RootStateOrAny, useSelector } from "react-redux";
import { ReactComponent as EditIcon } from "../../img/edit-icon.svg";
// import { ReactComponent as DeleteIcon } from "../../img/delete.svg";
import { Template } from "../../lib/interfaces/Template";
import { hasAccess } from "../RolesModule/hasAccess";
import { MENU_ADMIN_INFOTEMPLATE_WRITE } from "../../lib/const/permissions";
import ToggleColumns from "../ToggleableVersionsTable/ToggleColumns";

interface ITemplates {
  updateTemplate: (params: { id: number; body: Template }) => void;
  createTemplate: (params: { body: Template }) => void;
  deleteTemplate: (params: { id: number }) => void;
}

export const Templates = (props: ITemplates) => {
  const { createTemplate, updateTemplate, deleteTemplate } = props;
  const { templates } = useSelector((state: RootStateOrAny) => state.templates);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  const [editingForm] = Form.useForm();
  const [creatingForm] = Form.useForm();

  const sortedTemplates = [...templates].sort((a, b) => a.id - b.id);
  const [columns, setColumns] = useState<any[]>([
    {
      title: "ID шаблона",
      dataIndex: "id",
      key: "id",
      width: "80px",
      hidden: true,
    },
    {
      title: "Краткое наименование",
      dataIndex: "alias",
      key: "alias",
      width: "10%",
    },
    {
      title: "Тема",
      dataIndex: "topic",
      key: "topic",
      width: "20%",
    },
    {
      title: "Текст",
      dataIndex: "body",
      key: "body",
      width: "65%",
    },
    {
      dataIndex: "buttons",
      key: "buttons",
      render: (test, row: Template) => {
        return (
          hasAccess(MENU_ADMIN_INFOTEMPLATE_WRITE) && (
            <Space>
              <Popover content={() => "Редактировать"} placement="bottomRight">
                <Button
                  className="iconButton"
                  style={{ marginLeft: "auto" }}
                  icon={<EditIcon />}
                  onClick={() => {
                    editingForm.setFieldsValue(row);
                    setIsEditModalVisible(true);
                  }}
                />
              </Popover>
              {/* <Popconfirm */}
              {/*  title="Вы действительно хотите удалить шаблон?" */}
              {/*  placement="bottomRight" */}
              {/*  okText="Удалить" */}
              {/*  onConfirm={() => { */}
              {/*    deleteTemplate({ id: row.id }); */}
              {/*  }} */}
              {/* > */}
              {/*  <Popover content={() => "Удалить"} placement="bottomRight"> */}
              {/*    <Button */}
              {/*      className="iconButton" */}
              {/*      style={{ marginLeft: "auto" }} */}
              {/*      icon={<DeleteIcon />} */}
              {/*    /> */}
              {/*  </Popover> */}
              {/* </Popconfirm> */}
            </Space>
          )
        );
      },
      width: "5%",
    },
  ]);

  return (
    <>
      <Modal
        visible={isCreateModalVisible}
        title="Создание шаблона"
        okText="Сохранить"
        onCancel={() => {
          setIsCreateModalVisible(false);
          creatingForm.resetFields();
        }}
        onOk={() => {
          creatingForm.validateFields(["alias", "topic", "body"]).then(() => {
            createTemplate({
              body: creatingForm.getFieldsValue(),
            });
            setIsCreateModalVisible(false);
            creatingForm.resetFields();
          });
        }}
        destroyOnClose
      >
        <Form
          form={creatingForm}
          labelCol={{ span: 8 }}
          initialValues={{
            alias: "",
            topic: "",
            body: "",
          }}
        >
          <Form.Item
            label="Краткое наименование"
            name="alias"
            rules={[{ required: true, message: "" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Тема" name="topic" rules={[{ required: true, message: "" }]}>
            <Input />
          </Form.Item>
          <Form.Item label="Текст" name="body" rules={[{ required: true, message: "" }]}>
            <Input.TextArea rows={10} />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        visible={isEditModalVisible}
        title="Редактирование шаблона"
        okText="Сохранить"
        onCancel={() => {
          setIsEditModalVisible(false);
        }}
        onOk={() => {
          editingForm.validateFields(["alias", "topic", "body"]).then(() => {
            updateTemplate({
              id: editingForm.getFieldValue(["id"]),
              body: editingForm.getFieldsValue(),
            });
            setIsEditModalVisible(false);
          });
        }}
        destroyOnClose
      >
        <Form form={editingForm} labelCol={{ span: 8 }}>
          <Form.Item
            label="Краткое наименование"
            name="alias"
            rules={[{ required: true, message: "" }]}
          >
            <Input disabled />
          </Form.Item>
          <Form.Item label="Тема" name="topic" rules={[{ required: true, message: "" }]}>
            <Input />
          </Form.Item>
          <Form.Item label="Текст" name="body" rules={[{ required: true, message: "" }]}>
            <Input.TextArea rows={10} />
          </Form.Item>
        </Form>
      </Modal>
      <Row style={{ alignItems: "baseline", padding: "8px 12px" }} justify="space-between">
        <Col>
          <h1>Шаблоны писем</h1>
        </Col>
        {hasAccess(MENU_ADMIN_INFOTEMPLATE_WRITE) && (
          <Col>
            <Button type="primary" onClick={() => setIsCreateModalVisible(true)}>
              Добавить шаблон
            </Button>
          </Col>
        )}
      </Row>
      <Row justify="end" style={{ marginTop: "10px" }}>
        <ToggleColumns tableName="templates-table" columns={columns} setColumns={setColumns} />
      </Row>
      <Table
        rowKey={(record: Template) => record.id}
        columns={columns.filter(({ hidden }) => !hidden)}
        dataSource={sortedTemplates}
        pagination={{
          hideOnSinglePage: true,
        }}
      />
    </>
  );
};
